import * as React from 'react';
import { Grid } from "@material-ui/core";
import { Typography } from '@mui/material';
import {useEffect} from "react";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

export default function SubmitForm({ formData, handleQ, supperQValue }) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ textAlign: "left", paddingLeft: "8px" }}>
      <Grid container spacing={2}>
        {Object.entries(formData).map(([question, answer], index) => (
          <Grid item xs={12} key={index}>
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              {question}:
            </Typography>
            {Array.isArray(answer) ? (
              answer.map((line, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  style={{color: '#000000', fontWeight: 'bold', whiteSpace: 'pre-wrap' }}
                >
                  {line}
                </Typography>
              ))
            ) : (
              <Typography
                variant="body2"
                style={{color: '#000000', fontWeight: 'bold' }}
              >
                {answer || "Not provided"}
              </Typography>
            )}
          </Grid>
        ))}
      </Grid>
      <div>
        <br/>
        <hr/>
        <br/>
        <Typography variant="body2" style={{color: '#ce0101', fontWeight: 'bold' }}>
          For Lodge of benevolence members only:
        </Typography>
        <br/>
        <Typography variant="h6">
          Please confirm you attendance for Supper Night below
        </Typography>
        <br/>

        <div className="mason-question">
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={supperQValue}
              onChange={(e) => handleQ(e, 15)}
            >
              <FormControlLabel value="Attend & Dine" control={<Radio/>} label="Attend & Dine"/>
              <FormControlLabel value="Attend" control={<Radio/>} label="Attend"/>
              <FormControlLabel value="Apologies" control={<Radio/>} label="Apologies"/>
            </RadioGroup>
          </FormControl>
        </div>

      </div>

    </div>
  );
}
